/**
 * Consent-gated analytics.
 *
 * index.html ships only the PostHog stub (queues calls, zero network).
 * Nothing loads until initAnalyticsIfConsented() runs AND the user has
 * accepted the cookie banner (localStorage 'cookieConsent' === 'accepted',
 * written by CookieConsent.js). Declining — or never answering — means
 * PostHog is never initialized and no analytics traffic leaves the page.
 *
 * capture() is safe to call from anywhere: it silently no-ops when
 * analytics isn't initialized, so feature code never has to check consent.
 */

const POSTHOG_KEY = 'phc_yJW1VjHGGwmCbbrtczfqqNxgBDbhlhOWcdzcIJEOTFE';
const POSTHOG_HOST = 'https://us.i.posthog.com';

let initialized = false;

export const hasAnalyticsConsent = () => {
  try {
    return localStorage.getItem('cookieConsent') === 'accepted';
  } catch {
    return false;
  }
};

export const initAnalyticsIfConsented = () => {
  if (initialized || !hasAnalyticsConsent()) return;
  const ph = window.posthog;
  if (!ph || typeof ph.init !== 'function') return;
  try {
    ph.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      person_profiles: 'identified_only',
      // We collect delivery addresses and due dates in forms — never record
      // sessions, and mask everything if a future config change enables it.
      disable_session_recording: true,
      mask_all_text: true,
      mask_all_element_attributes: true,
      respect_dnt: true,
    });
    initialized = true;
  } catch {
    /* analytics must never break the app */
  }
};

/** Fire a product event. No-op without consent/initialization. */
export const capture = (event, properties = {}) => {
  if (!initialized) return;
  try {
    window.posthog?.capture?.(event, properties);
  } catch {
    /* ignore */
  }
};

export default { initAnalyticsIfConsented, capture, hasAnalyticsConsent };
